import { FlightEvaluationRepository } from '@src/main/modules/reports/flight/domain/flight-evaluation.repository';

export const softDeleteFlightEvaluation = async (
  repository: FlightEvaluationRepository,
  evaluationId: string,
): Promise<void> => await repository.softDelete(evaluationId);
